import { Button } from "antd";
import React, { Component } from "react";

export default class Introduce extends Component {
  render() {
    return (
      <div className="introduce">
        <div className="title">
          Hướng dẫn sử dụng{" "}
          <i className="fas fa-times icon-close" onClick={this.props.close}></i>
        </div>
        <div style={{ padding: "25px" }}>
          <iframe
            allowFullScreen="allowFullScreen"
            frameBorder="0"
            className="video"
            src="https://www.youtube.com/embed/if8Amp1QtE4"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </div>
        <div className="download-tutorial">
          <Button type="link" className="text-download" href="https://drive.google.com/u/0/uc?id=1DjSA7QtKIuaWHlIMimvdzIE7aVtr7HLe&export=download">
            Tải file PDF hướng dẫn sử dụng
          </Button>
        </div>
      </div>
    );
  }
}

